import { useState } from "#app";

export function usePageTitle() {
  const title = useState<string>("pageTitle", () => "Artech Admin");
  return {
    title,
    set: (v: string) => {
      title.value = v;
    },
  };
}
